import notificationInstance from './notification';

export default notificationInstance;
